export default "__VITE_ASSET__Cj5U45B2__"